export const SET_ROOM = "SET_ROOM";
export const GET_CHATS = "GET_CHATS";
export const RESET_CHATS = "RESET_CHATS";
export const CHAT_SNAPSHOT = "CHAT_SNAPSHOT";
